export enum StorageTypes {
  bceLink,
  client,
  location,
  clientListIsActive,
  theme,
  invoiceOptions,
  pinMenu,
  glInterfaceReportOptions,
  futureClients
}
